import styled from 'styled-components';
import PageLoading from '../../components/PageLoading';


const StyledOAuthCallbackPageLoading = styled(PageLoading)`
  left: 0;
  width: 100%;
`;

export {
  StyledOAuthCallbackPageLoading
}